import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

// UTILITY
import { getLink } from '@/utility/routes';
import { getLinksByType } from '@/utility/wp';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { CardContainer } from './styles';

const AuthorInfo = ({ data, date, type, location, hideAuthor }) => {
  const links = getLinksByType(type);
  const avatar =
    (data?.simple_local_avatar && data?.simple_local_avatar['96']) ||
    (data?.avatar_urls && data?.avatar_urls['48']);

  if (hideAuthor && date)
    return (
      <CardContainer className="author">
        {date && <Typography className="author__date">{date}</Typography>}
      </CardContainer>
    );

  return (
    <CardContainer className="author">
      <RouterLink to={getLink(links.author, { slug: data.slug })} location={location}>
        {avatar && <img src={avatar} className="author__image" alt={data.name} />}
        <div className="author__info">
          <Typography className="author__name">{data.name}</Typography>
          {date && <Typography className="author__date">{date}</Typography>}
        </div>
      </RouterLink>
    </CardContainer>
  );
};

AuthorInfo.defaultProps = {
  data: {},
  date: '',
  location: '',
  type: 'blog',
  hideAuthor: false,
};

AuthorInfo.propTypes = {
  data: PropTypes.object,
  date: PropTypes.string,
  type: PropTypes.oneOf(['blog', 'news']),
  location: PropTypes.string,
  hideAuthor: PropTypes.bool,
};

export default React.memo(AuthorInfo);
